export var FlowDesignerFeature;
(function (FlowDesignerFeature) {
    FlowDesignerFeature[FlowDesignerFeature["DataPanel"] = 0] = "DataPanel";
    FlowDesignerFeature[FlowDesignerFeature["Debug"] = 1] = "Debug";
    FlowDesignerFeature[FlowDesignerFeature["Integration"] = 2] = "Integration";
    FlowDesignerFeature[FlowDesignerFeature["ClipboardButtons"] = 3] = "ClipboardButtons";
    FlowDesignerFeature[FlowDesignerFeature["ZoomBar"] = 4] = "ZoomBar";
    FlowDesignerFeature[FlowDesignerFeature["HideZoomButtons"] = 5] = "HideZoomButtons";
    FlowDesignerFeature[FlowDesignerFeature["FlowActions"] = 6] = "FlowActions";
    FlowDesignerFeature[FlowDesignerFeature["ViewSelector"] = 7] = "ViewSelector";
    FlowDesignerFeature[FlowDesignerFeature["UndoRedoButtons"] = 8] = "UndoRedoButtons";
    FlowDesignerFeature[FlowDesignerFeature["CreateCheckpoints"] = 9] = "CreateCheckpoints";
    FlowDesignerFeature[FlowDesignerFeature["InfoPanel"] = 10] = "InfoPanel";
    FlowDesignerFeature[FlowDesignerFeature["SamplePanel"] = 11] = "SamplePanel";
    FlowDesignerFeature[FlowDesignerFeature["StepsPanel"] = 12] = "StepsPanel";
    FlowDesignerFeature[FlowDesignerFeature["StepsByTypePanel"] = 13] = "StepsByTypePanel";
    FlowDesignerFeature[FlowDesignerFeature["StepsToolbox"] = 14] = "StepsToolbox";
    FlowDesignerFeature[FlowDesignerFeature["StepEditMenu"] = 15] = "StepEditMenu";
    FlowDesignerFeature[FlowDesignerFeature["StepPropertiesPanel"] = 16] = "StepPropertiesPanel";
    FlowDesignerFeature[FlowDesignerFeature["StepReplacementOnDrop"] = 17] = "StepReplacementOnDrop";
    FlowDesignerFeature[FlowDesignerFeature["StepTemplates"] = 18] = "StepTemplates";
    FlowDesignerFeature[FlowDesignerFeature["StepGrouping"] = 19] = "StepGrouping";
    FlowDesignerFeature[FlowDesignerFeature["RotateOffByDefault"] = 20] = "RotateOffByDefault";
    FlowDesignerFeature[FlowDesignerFeature["ShowRotateAction"] = 21] = "ShowRotateAction";
    FlowDesignerFeature[FlowDesignerFeature["ShowGridAction"] = 22] = "ShowGridAction";
    FlowDesignerFeature[FlowDesignerFeature["DiagramInStepSelection"] = 23] = "DiagramInStepSelection";
    FlowDesignerFeature[FlowDesignerFeature["FlowName"] = 24] = "FlowName";
    FlowDesignerFeature[FlowDesignerFeature["CloseCrossSign"] = 25] = "CloseCrossSign";
    FlowDesignerFeature[FlowDesignerFeature["CanMoveSteps"] = 26] = "CanMoveSteps";
    FlowDesignerFeature[FlowDesignerFeature["CanRePortLinks"] = 27] = "CanRePortLinks";
    FlowDesignerFeature[FlowDesignerFeature["CanReLinkLinks"] = 28] = "CanReLinkLinks";
    FlowDesignerFeature[FlowDesignerFeature["CanReshapeLinks"] = 29] = "CanReshapeLinks";
    FlowDesignerFeature[FlowDesignerFeature["CanRemoveLinks"] = 30] = "CanRemoveLinks";
    FlowDesignerFeature[FlowDesignerFeature["CanAddLinks"] = 31] = "CanAddLinks";
    FlowDesignerFeature[FlowDesignerFeature["CanEditLinks"] = 32] = "CanEditLinks";
    FlowDesignerFeature[FlowDesignerFeature["ProtoPropertyGrid"] = 33] = "ProtoPropertyGrid";
})(FlowDesignerFeature || (FlowDesignerFeature = {}));
;
